/**
 * 用户相关
 */

import http from "@/utils/axiosoUtil";
import { Dialog } from "vant";
// import regular from "@src/utils/regular";

const mutations = {
  setQrInfo(state, payload) {
    state.qrInfo = payload;
  }
};

const actions = {
  getUserBaseInfo(_, functionType = "1") {
    return new Promise((resolve, reject) => {
      http
        .post(http.api.USER_BASE_INFO, {
          functionType
        })
        .then(res => {
          resolve(res);
        })
        .catch(message => {
          reject(message);
        });
    });
  },
  getUserBaseQrcodeInfo({ state, commit }) {
    return new Promise(resolve => {
      if (state.qrInfo != null) {
        resolve(state.qrInfo);
      } else {
        http
          .post(http.api.USER_QRCODE_CARD, {
            functionType: "1"
          })
          .then(res => {
            if (res.flag == "0") {
              Dialog.confirm({
                message: "“智慧多码”模块需要领用多码后使用，是否立即领用"
              }).then(() => {
                http.route("/ecode", "1");
              });
            } else {
              commit("setQrInfo", res);
              resolve(res);
            }
          });
      }
    });
  }
};

const state = {
  hospitalInfo: {},
  // 三码信息
  qrInfo: null
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
